export var WalletConnectionStatus;
(function (WalletConnectionStatus) {
    WalletConnectionStatus["Untouched"] = "Untouched";
    WalletConnectionStatus["Connected"] = "Connected";
    WalletConnectionStatus["Disconnected"] = "Disconnected";
})(WalletConnectionStatus || (WalletConnectionStatus = {}));
